module.exports = __webpack_public_path__ + "img/push.3d26b7c0.svg";